import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';

import HaskellSvgColor from '../assets/haskell.svg';

export const HaskellColor = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="color-lang-haskell" className={cx('sdkIcon', className)} size={size} {...props}>
    <HaskellSvgColor />
  </LegacyIcon>
);
